import React from "react";

const PaymentsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M25 10.9468H11C9.89543 10.9468 9 11.8422 9 12.9468V23.9468C9 25.0514 9.89543 25.9468 11 25.9468H25C26.1046 25.9468 27 25.0514 27 23.9468V12.9468C27 11.8422 26.1046 10.9468 25 10.9468Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.4468H27"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21.4468H16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PaymentsIcon;
